import {
  MsalModule,
  MsalRedirectComponent,
  MsalGuard,
  MsalInterceptor,
  MsalGuardConfiguration,
  MsalBroadcastService,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalInterceptorConfiguration,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
  Configuration,
  IPublicClientApplication,
} from '@azure/msal-browser'; // InteractionType added to imports

export const loginRequest = {
  scopes: ['openid'],
};
